export default resolveExports;

function resolveExports(bundle) {
	var bundleExports = {};

	bundle.entryModule.exports.forEach(function (x) {
		if (x.specifiers) {
			x.specifiers.forEach(function (s) {
				var module = undefined;
				var name = undefined;

				if (s.origin) {
					module = s.origin.module;
					name = s.origin.name;
				} else {
					module = bundle.entryModule;
					name = s.name;
				}

				addExport(module, name, s.as);
			});
		} else if (!x.isDefault && x.name) {
			addExport(bundle.entryModule, x.name, x.name);
		}
	});

	function addExport(module, name, as) {
		if (!bundleExports[module.id]) {
			bundleExports[module.id] = {};
		}

		bundleExports[module.id][name] = as;
	}

	return bundleExports;
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/combine/resolveExports.js.01-babel.map